module.exports = __webpack_public_path__ + "img/logo.e8cd2d4f.svg";